import { render } from "./CompanyUtilizationIndex.vue?vue&type=template&id=4e1dc7bc"
import script from "./CompanyUtilizationIndex.vue?vue&type=script&lang=js"
export * from "./CompanyUtilizationIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__